<template>
	<es-layout
		leftArrow="{{true}}"
		navbarTitle="订单详情"
		navbarStyle="{{navbarStyle}}"
		esMainStyle="{{esMainStyle}}"
	>
		<!-- 订单状态及操作按钮-->
		<order-state-head
			iconName="exclamation-circle"
			title="改签失败"
			subTitle="改签失败，建议您更改坐席或车次信息后重新改签"
			isSimplified="{{true}}"
		/>
		<!-- 车次座席-->
		<order-info-list
			bind:click="showSSI"
			class="order-body"
			orderList="{{orderList}}"
		/>
	</es-layout>
	<drawer-bottom
    show="{{ showStayInfo }}"
    title="时刻表"
    bind:close="closeSSI"
    showDefaultNav
  >
    <station-stay-info
      wx:if="{{ showStayInfo }}"
      stayInfo="{{stayInfo}}"
      wx:style="height:100%;"
    />
  </drawer-bottom>
</template>

<script>
 	import { mpx, createPage } from '@didi/es-mpx-creator'
 	import store from '@/store'
	import { STORAGE_CHANGE_FAILED_INFO } from '@/utils/train-storage'
  import { getStorage } from '@/utils/storage'
  import { formatDate } from '@/utils/baseDate'

 	createPage({
 		data() {
 			return {
				orderList: [],
        showStayInfo: false,
 			}
 		},
 		computed: {
      esMainStyle() {
        return {
					'background-image': 'linear-gradient(180deg, #1473ff 0%, #1473ff 30%, #f0f1f4 30%, #f0f1f4 100%)'
				}
      },
 			navbarStyle() {
 				return {
 					color: '#fff',
 					fontSize: '18px',
 					fontWeight: 600,
 					background: '#1473ff',
 					fontFamily: 'PingFangSC',
 				}
 			}
 		},
 		attached() {
			const order_detail = getStorage(STORAGE_CHANGE_FAILED_INFO)
			this.orderList = [{
				...order_detail,
				is_change: 0,
				tickets_info: order_detail.tickets_info.map(item => ({
					...item,
					status_name: '改签失败',
					status_color: '#E12E2E'
				}))
			}]
 		},
		methods: {
      ...store.mapMutations({
        setChangeFailedOrderInfo: 'change.setChangeFailedOrderInfo',
      }),
      // 时刻表
      closeSSI() {
        this.showStayInfo = false
      },
      showSSI({ detail }) {
        const trainDetail = e?.detail || {}
        this.stayInfo = {
          train_date: formatDate(trainDetail?.start_time),
          train_code: trainDetail?.train_code || '',
          train_no: trainDetail?.train_no || '',
          from_station_name: trainDetail?.from_station_name || '',
          to_station_name: trainDetail?.to_station_name || '',
        }
        this.showStayInfo = true
      },
		},
    destroyed() {
			this.setChangeFailedOrderInfo({})
    },
 	})
</script>

<style lang="stylus" scoped>
 .order-body
 	padding 12px 12px 120px 12px
 	min-height 50vh
 	border-radius 16px 16px 0 0
 	background-image linear-gradient(179deg, #FAFBFD 0%, #F0F1F4 6%, #F0F1F4 100%)
</style>

<script name="json">
 	module.exports = {
 		usingComponents: {
 			'order-info-list': '@/components/order-info-list',
 			'order-state-head': './components/order-detail-head-state-card',
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
      'station-stay-info': '@/components/station-stay-info',
 		}
 	}
</script>
